<script>
	import { slugify, tryEval } from "cando-util";

	export let value;
	export let name;
	export let options = [{ option: "Option 1", value: "Value 1" }];
	export let disabled = false;
	export let cls = "my-auto select select-bordered select-primary";
	export let tabindex = 0;
	export let handleChange = null;
	export let id = slugify(name);
	export let optionClass = "";
	export let key = "";
	export let readonly = false;
	export let itemId;

	const handleSelectChange = (e) => {
		console.log(e.target.value);
		value = e.target.value;
		handleChange(e);
	};

	$: processedOptions =
		typeof options === "string"
			? (tryEval(options) || "")
					.split("\n")
					.map((o) => ({ option: o, value: o }))
			: options;
</script>

<div>
	{#if handleChange !== null}
		<select
			{id}
			{disabled}
			{name}
			{value}
			class={cls}
			{tabindex}
			onchange={handleSelectChange}
			{key}
			{itemId}
		>
			{#if !readonly}
				<!-- <option class="p-2 sm:p-4" value="">(none)</option> -->
				{#if !processedOptions.map((o) => o.value || o).includes(value)}
					<option class={optionClass} {value} {key}>
						{value || ""}
					</option>
				{/if}
				{#each processedOptions as option}
					<option
						class={optionClass}
						value={option.value !== undefined
							? option.value
							: option}
						{key}
					>
						{option.option || option.label || option}
					</option>
				{/each}
			{/if}
		</select>
	{:else}
		<select {id} {disabled} {name} bind:value class={cls} {tabindex} {key}>
			{#if !readonly}
				<!-- <option class="p-2 sm:p-4" value="">(none)</option> -->
				{#if !processedOptions.map((o) => o.value || o).includes(value)}
					<option class={optionClass} {value} {key}>
						{value || ""}
					</option>
				{/if}
				{#each processedOptions as option}
					<option
						class={optionClass}
						value={option.value !== undefined
							? option.value
							: option}
						{key}
					>
						{option.option || option.label || option}
					</option>
				{/each}
			{/if}
		</select>
	{/if}
</div>
